const es = {
  noResults: () => {
    return 'No hay resultados'
  },
  searching: () => {
    return 'Buscando..'
  },
  inputTooShort: () => {
    return 'Debe ingresar mínimo 3 caracteres'
  }
}

const pt = {
  noResults: () => {
    return 'Não há resultados'
  },
  searching: () => {
    return 'procurando...'
  },
  inputTooShort: () => {
    return 'Você deve inserir pelo menos 3 caracteres'
  }
}

export { es, pt }



// WEBPACK FOOTER //
// app/javascript/src/plugins/select2/language.js